import React, { useState } from 'react';
import { Card, Button, Row, Col, Form, FormControl, Modal, Spinner } from 'react-bootstrap';
import { FaPlus, FaSearch, FaEraser, FaCashRegister, FaEye } from 'react-icons/fa';
import api from '../../api/apiweb-cierrecaja.js';
import PrintCierreCaja from './PrintCierreCaja';
import CierreCajaNuevo from './CierreCajaNuevo';
import './CierreCaja.scss';

const moment = require('moment-timezone');

const currency = (n) => new Intl.NumberFormat('es-CL').format(n ?? 0);

function CierreCaja(props) {
  const initialDate = moment().tz('America/Santiago').format().slice(0, 10);
  const [startDate, setStartDate] = useState(initialDate);
  const [endDate, setEndDate] = useState(initialDate);
  const [searching, setSearching] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [modalDescarga, setModalDescarga] = useState(false);
  const [mensajeFallo, setMensajeFallo] = useState(false);
  const [modalDescargaMensaje, setModalDescargaMensaje] = useState('');
  const [cierreCajaData, setCierreCajaData] = useState(null);
  const [cierreCajaNuevoModal, setCierreCajaNuevoModal] = useState(false);

  const __DEV__ = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

  const busqueda = async () => {
    if (!startDate || !endDate || startDate > endDate) {
      setModalDescarga(true);
      setMensajeFallo(true);
      setModalDescargaMensaje('Selecciona un rango de fechas válido');
      return;
    }
    setSearching(true);
    setModalDescarga(true);
    setMensajeFallo(false);
    setModalDescargaMensaje('Procesando');
    api.getData({ startDate, endDate }).then(
      (data) => {
        setModalDescarga(false);
        if (__DEV__) { console.log(data); }
        setResponseData(data.data.records);
        setSearching(false);
      },
    ).catch(() => {
      setSearching(false);
      setModalDescargaMensaje('Error en la descarga');
      setMensajeFallo(true);
    });
  };

  const verCierreCaja = (cierrecaja_id) => {
    if (cierrecaja_id == null) return;
    setModalDescarga(true);
    setMensajeFallo(false);
    setModalDescargaMensaje('Procesando');
    api.getCierreCaja({ cierrecaja_id }).then(
      (data) => {
        setModalDescarga(false);
        if (__DEV__) { console.log(data); }
        setCierreCajaData(data.data);
        setSearching(false);
      },
    ).catch(() => {
      setSearching(false);
      setModalDescargaMensaje('Error en la descarga');
      setMensajeFallo(true);
    });
  };

  const closeModalCierreCaja = () => setCierreCajaData(null);
  const mostrarModalCrearCierre = () => setCierreCajaNuevoModal(true);
  const closeModalCierreCajaNuevo = () => setCierreCajaNuevoModal(false);
  const closeModal = () => setModalDescarga(false);
  const showLoadingModal = () => setModalDescarga(true);
  const closeLoadingModal = () => setModalDescarga(false);
  const setMessageLoadModal = () => {
    setModalDescargaMensaje('Error al ingresar cierre caja');
    setMensajeFallo(true);
  };

  const limpiar = () => {
    setStartDate('');
    setEndDate('');
  };

  return (
    <>
      <div className="CierreCaja">
        <div className="page-header page-header-row">
          <div>
            <h1 className="page-title">Cierre de Caja</h1>
            <p className="page-subtitle">Consulta cierres realizados y genera nuevos cierres por cajero</p>
          </div>
          <Button variant="primary" className="btn-add" onClick={mostrarModalCrearCierre}>
            <FaPlus className="me-2" />Nuevo cierre
          </Button>
        </div>

        <Card className="search-card">
          <Card.Header className="search-card-header">
            <FaSearch className="me-2" />
            Filtros
          </Card.Header>
          <Card.Body>
            <Row className="g-3">
              <Col sm={12} md={6} lg={4}>
                <Form.Label>Desde</Form.Label>
                <FormControl type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
              </Col>
              <Col sm={12} md={6} lg={4}>
                <Form.Label>Hasta</Form.Label>
                <FormControl type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
              </Col>
            </Row>
            <div className="search-actions">
              <Button variant="primary" disabled={searching} onClick={busqueda}>
                <FaSearch className="me-2" />Buscar
              </Button>
              <Button variant="outline-secondary" onClick={limpiar} className="ms-auto">
                <FaEraser className="me-2" />Limpiar
              </Button>
            </div>
          </Card.Body>
        </Card>

        <Card className="search-card mt-4">
          <Card.Header className="search-card-header">
            <FaCashRegister className="me-2" />
            Cierres
            {responseData && responseData.length > 0 && (
              <span className="results-count">{responseData.length}</span>
            )}
          </Card.Header>
          <Card.Body className="p-0">
            {responseData && responseData.length > 0 ? (
              <div className="table-responsive">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Local</th>
                      <th>Cajero</th>
                      <th>Usuario</th>
                      <th className="text-end">Secuencia</th>
                      <th className="text-end">Cant. Docs</th>
                      <th className="text-end">Tarjeta</th>
                      <th className="text-end">Efectivo</th>
                      <th className="text-end">Total</th>
                      <th className="text-center">Ver</th>
                    </tr>
                  </thead>
                  <tbody>
                    {responseData.map((e) => (
                      <tr key={e.cierrecaja_id}>
                        <td className="nowrap">{e.termino_fecha}</td>
                        <td>{e.local}</td>
                        <td>{e.device_name}</td>
                        <td>{e.createuser}</td>
                        <td className="text-end num">{e.secuencia_dia}</td>
                        <td className="text-end num">{e.cantidaddocumentos}</td>
                        <td className="text-end num">${currency(e.montototaltarjeta)}</td>
                        <td className="text-end num">${currency(e.montototalefectivo)}</td>
                        <td className="text-end num cell-total">
                          ${currency((e.montototaltarjeta ?? 0) + (e.montototalefectivo ?? 0))}
                        </td>
                        <td className="text-center">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            title="Ver detalle"
                            onClick={() => verCierreCaja(e.cierrecaja_id)}
                          >
                            <FaEye />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="empty-state">
                <FaCashRegister className="empty-state-icon" />
                <p className="empty-state-text">
                  {responseData === null
                    ? 'Selecciona un rango y presiona "Buscar"'
                    : 'No se encontraron cierres en el rango seleccionado'}
                </p>
              </div>
            )}
          </Card.Body>
        </Card>
      </div>

      {cierreCajaData && (
        <PrintCierreCaja cierreCajaData={cierreCajaData} onHide={closeModalCierreCaja} />
      )}
      {cierreCajaNuevoModal && (
        <CierreCajaNuevo
          show={cierreCajaNuevoModal}
          onHide={closeModalCierreCajaNuevo}
          devices={props.devices}
          showLoadingModal={showLoadingModal}
          closeLoadingModal={closeLoadingModal}
          setMessageLoadModal={setMessageLoadModal}
        />
      )}

      <Modal show={modalDescarga} onHide={closeModal} centered>
        <Modal.Header closeButton={mensajeFallo}>
          <Modal.Title>Cierre de caja</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          {!mensajeFallo && <Spinner animation="border" variant="primary" className="mb-3" />}
          <div className="modal-message">{modalDescargaMensaje}</div>
        </Modal.Body>
        {mensajeFallo && (
          <Modal.Footer>
            <Button variant="secondary" onClick={closeModal}>Cerrar</Button>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
}

export default CierreCaja;
